import React, {useState, useEffect} from "react"
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby"

import Layout from "../components/layout";
import SEO from "../components/seo";

import OffcDetails from "../components/PersonDetails/OfficeDetails/OfficeDetails"
import OfficeLinks from "../components/PersonDetails/OfficeLinks"
import WhatWeDo from "../components/PersonDetails/WhatWeDo/WhatWeDo";
import ContactMap from "../components/ContactPage/ContactMap/ContactMap";
import Loadable from "@loadable/component"
import ContactFormBottom from "../components/FormBottom/ContactFormBottom";
import Testimonials from "../components/Testimonials/Testimonials";

import $ from "jquery"
import BrandLogo from "../images/logo002.svg";

const Team = Loadable(() => import ('../components/Home/OurTeam/Team'))

function OfficeDetailsTemplate(props) {

  const [search, setSearch] = useState(false);
  const [open, setOpen] = useState(false);
  const [menu_heading, setMenuHeading] = useState(false);
  const [state, setState] = React.useState({
      showMenu: false,
  });

  const office_details = props.pageContext.data;
 //console.log("office_details", office_details)
  const global_data = useStaticQuery(graphql`
    query OfficeContactForm {
      glstrapi{
        globalModule {
          Office_Contact_Form {
            Office_Contact_Module {
              Dynamics_User_ID
              Email_ID
              office {
                id
                Name
              }
            }
          }
        }
      }
    }
  `)

  var global_module = global_data.glstrapi?.globalModule?.Office_Contact_Form?.Office_Contact_Module;

  var myMetaTitle = "";
  var myMetaDesc = "";
  var myMetaImg = "";
  var page_path = props.pageContext.slug;

  if( props?.pageContext?.title ) {
      myMetaTitle = "Property Consultants and Auctioneers London";
      myMetaDesc = "Our property consultants and auctioneers in London offer expert property advice for selling, buying, letting, and valuations. Contact us to see how we can help.";
  }

  if (props.pageContext.title == 'City and City Fringe') {
      myMetaTitle = "Property Consultants & Advisors | Commercial Agents London";
      myMetaDesc = "Our property consultants in City and City Fringe offer specialist property advice when selling, buying, letting, renting and valuing. Contact us to get assistance from expert commercial agents in London.";
  }

  let processedImages = JSON.stringify({});
  const STAGE_ENV = process.env.GATSBY_STRAPI_GGFX_ENV || "i.dev";

  if (office_details?.imagetransforms?.Image_Transforms) {
    processedImages = office_details?.imagetransforms?.Image_Transforms;
    var resized_images = JSON.parse(processedImages);
    const SrcCftle = office_details?.Image && office_details?.Image?.url.substring(office_details?.Image && office_details?.Image?.url.indexOf(STAGE_ENV));
    const ProcessedUrl = resized_images[SrcCftle] && resized_images[SrcCftle]?.jpg ? resized_images[SrcCftle]?.jpg['480x320'] :
                         resized_images[SrcCftle]?.png ? resized_images[SrcCftle]?.png['480x320'] : office_details?.Image && office_details?.Image?.url;
    myMetaImg = ProcessedUrl;
  }

  const scrollToPos = (div_id, timeout) =>{
    setTimeout(function(){
      $('html, body').animate({
        scrollTop: $("#"+div_id).offset().top - 100
      }, 'smooth');
    }, timeout ? timeout : 0)
  }

  const handlerClick = () => {
    setState({ ...state, showMenu: !state.showMenu });
    if (state.showMenu == true) {
        document.body.className = "";
    } else {
        document.body.classList.add("overflow-hidden");
    }
  };

  const openHam = () => {
      setOpen(!open);
  };

  const openSearch = (menu_title) => {
      setSearch(!search);
      handlerClick();
      setMenuHeading(menu_title)
  };
  const closeSearch = () => {
      setSearch(!search);
      handlerClick();
  };

  useEffect(() => {
    var prevState = props.location?.state;
    if (prevState && prevState.form_id && office_details?.Name) {
      scrollToPos(prevState.form_id, 500);
    }
  }, []);

  var office_det = global_module ? global_module.filter(item => item?.office?.id === office_details?.id) : [];

  return (
    office_details ? (
      <Layout GQLPage={office_details} Layout="Without_Banner" classNames={"search-header person-header details-header office_details_templates"} closeSearch={closeSearch} handlerClick={handlerClick} menu_heading={menu_heading} search={search} open={open} popular_search_slug="contact-us">

        <SEO title={myMetaTitle} description={myMetaDesc} image={myMetaImg}/>

        <Helmet bodyAttributes={{ class: `body_cls` }} />

        <OfficeLinks page_title={office_details && office_details.Name}/>

        <div className="people_details_wrap offc_det">

          <OffcDetails office_details={office_details} handleClick={scrollToPos} location={props.location} />

          { office_details.What_We_Do && <WhatWeDo What_We_Do={office_details.What_We_Do}/> }

          <Team Module={office_details?.Modules?.length > 0 && office_details?.Modules.filter(Module => Module.__typename === "ComponentComponentOurPeopleComponent")[0]}/>

          {office_details.Latitude && office_details.Longitude && <ContactMap office_details={office_details} all_tabs={false} infoWindow={false} />}

          <Testimonials Module={office_details?.Modules?.length > 0 && office_details?.Modules.filter(Module => Module.__typename === "ComponentComponentReviewsModule")[0]}/>

          <ContactFormBottom Module={office_details?.Modules?.length > 0 && office_details?.Modules.filter(Module => Module.__typename === "ComponentComponentShowContactFormModule")} member_name={office_details.Name} form_name={(office_details.Name).toLowerCase()} to_email_id={office_details.Form_Email_ID} to_user_id={office_details.Form_User_ID} openSearch={openSearch} openHam={openHam} search={search} open={open} type={office_details.Type} sub_type={office_details.Sub_Type} subject={"Office Contact"} formLabel={`Contact - ${office_details.Name}`} />

        </div>

      </Layout>
    ) : (
      <section className={"loader-wrapper"}>
        <div id="loader-wrapper">
          <div id="loader" className="new-loader">
            <img className="logo-white" src={BrandLogo} alt="logo"/>
          </div>
        </div>
      </section>
    )
  )
}

export default OfficeDetailsTemplate
